export default __webpack_public_path__ + "static/media/G_icon.b7b4ff7c.svg";